import axios from "axios";
import {configUrl} from "config.js";

import { useMutation, useQueryClient } from "react-query";
export default function useUserDataCleanup() {
  let queryClient = useQueryClient();
  return useMutation(
    async (testId) => {
      await axios.delete(
        `${configUrl.AssessmentServer}/api/Tests/userDataCleanUp/${testId}`
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("tests");
      },
    }
  );
}
